
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import sericeDataService from "./serviceDataService";



const initialState = {
    services: [],
    isError: false,
    isLoading: false,
    isSuccess: false,
    message: "",
}

export const getServices = createAsyncThunk("services", async (thunkAPI) => {
    try {
        return await sericeDataService.sericeData();
    } catch (err) {
        const message = (
            err.response && err.response.data && err.response.data.message
        ) || err.message || err.toString();
        return thunkAPI.rejectWithValue(message)
    }
})

export const serviceDataSlice = createSlice({
    name: "services",
    initialState,
    reducers: {
        reset: (state) => {
            state.isLoading = false;
            state.isSuccess = false;
            state.isError = false;
            state.message = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(
                getServices.pending, (state) => {
                    state.isLoading = true
                }

            )
            .addCase(
                getServices.fulfilled, (state, action) => {
                    state.isLoading = false;
                    state.isSuccess = true;
                    state.services = action.payload;

                }
            )
            .addCase(
                getServices.rejected, (state, action) => {
                    state.isLoading = false;
                    state.isError = true;
                    state.message = action.payload;
                    state.services = null
                }
            )
    }
})

export const { reset } = serviceDataSlice.actions;
export default serviceDataSlice.reducer;